import React from "react";

const CreditSection = ({ details }) => {
    return (
        <section className="mt-14 mb-14 sm:mb-28">
            {/* Titre principal en full width, centré */}
            <div className="w-full max-w-7xl mx-auto px-4 sm:px-8">
                <h2 className="text-3xl text-center tracking-tighter font-semibold text-gray-900">
                    MAD<span className="text-greenlogo">ATLAS</span><span className="text-danger">.</span>
                </h2>
                <p className="font-normal text-center text-gray-600 mt-1">
                    Cartes, images et données géographiques de Madagascar, de l'Océan Indien et des Afriques
                </p>
            </div>

            {/* Contenu détaillé */}
            <div className="w-full max-w-5xl mx-auto p-8 space-y-9 sm:space-y-12 text-gray-700 text-base sm:text-lg">
                {details.map((item, index) => (
                    <div key={index} className="text-center">
                        {/* Titre du détail */}
                        <div className="font-bold text-greenprimary mb-2 sm:mb-3 text-base sm:text-lg">
                            {item.label}
                        </div>

                        {/* Contenu du détail */}
                        <div className="font-normal">
                            {item.name && (
                                <span>
                                    {item.link ? (
                                        <a
                                            href={item.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="underline text-blue-600 font-normal"
                                        >
                                            {item.name}
                                        </a>
                                    ) : (
                                        <span className="font-normal">{item.name}</span>
                                    )}
                                </span>
                            )}
                            {item.role && (
                                <span className="italic">, {item.role}</span>
                            )}
                            {item.work && (
                                <>
                                    {" "}
                                    <span>
                                        {item.link && !item.name ? (
                                            <a
                                                href={item.link}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="underline text-blue-600 font-normal"
                                            >
                                                {item.work}
                                            </a>
                                        ) : (
                                            item.work
                                        )}
                                    </span>
                                </>
                            )}
                            {/* Cas où il n'y a que le champ work */}
                            {!item.name && !item.role && item.work && !item.link && (
                                <span>{item.work}</span>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default CreditSection;